import { ReactElement } from "react";

import { Head } from "@/components/seo";
import { AccueilComponent } from ".";

export default function HomePage() {
  return (
    <>
      <Head title="Accueil | Jourgui" description="Jourgui"></Head>
      <AccueilComponent />
    </>
  );
}
